import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '../../theme/Theme.js';
import { Root } from './styled.js';
import { useColumns } from './hooks/useColumns.js';
import { useSize } from './hooks/useSize.js';

const BaseTable = (_a, ref) => {
    var _b, _c;
    var { size = 'medium' } = _a, props = __rest(_a, ["size"]);
    const theme = useTheme();
    const sizeProp = useSize(size);
    const columns = useColumns(props.columns);
    const isRowCursorPointer = typeof ((_c = (_b = props === null || props === void 0 ? void 0 : props.onRow) === null || _b === void 0 ? void 0 : _b.call(props, {})) === null || _c === void 0 ? void 0 : _c.onClick) === 'function';
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-table' }, props, { "$theme": theme, "$pointer": isRowCursorPointer, ref: ref, "$size": size, size: sizeProp, columns: columns, pagination: false })));
};
const Table = React.forwardRef(BaseTable);
Table.displayName = 'Table';

export { Table };
//# sourceMappingURL=Table.js.map
